import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const dot: Collection = {
  id: 'ona-dot',
  brandId: 'ona',
  brandName: 'Ona',
  icon: 'ona.png',
  title: 'Dot',
  subTitle: 'Speels & kleurrijk',
  banner: 'dot/dot-banner.jpg',
  items: [
    {
      id: 'ona-dot-2',
      collectionImages: [
        {
          image: 'dot/Dot_3.jpg',
          width: CollectionBannerWidth['100%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'ona-dot-1',
      collectionImages: [
        {
          image: 'dot/Dot.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'dot/Dot_2.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'dot/Dot_5.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    'f8091e3f-00c8-495b-87fd-8b056ebda76f',
    'c20b58c5-e3b7-4bff-becd-e1ff81ec3bcd',
    'a1a07352-8fdb-42a8-90da-fd752adae30c',
    'd91bdabe-13c5-4665-a236-e5c2c29183ca',
    'fbb7b61c-0998-4c0d-a0e9-99f5e1e2e0e8',
    '3bbe54f1-a86f-48bd-8467-02aef65c63ae',
    'f84a5809-02ed-43f5-b79e-5d27cc46893f',
    '87654892-4b81-4ed1-bf8d-ecf5eb93e378',
    '3683211b-a61a-4eab-bedf-ec705084750a',
    'f17b9ca3-9575-4813-b764-eea1bfafeb00',
    '5b6b8bee-6bea-457b-8801-b7482013a973',
    'f527e58a-f03c-43be-9a31-ac09b824658f',
    'd3f74ebb-74db-4828-ad06-6de1c53b51b2',
    'c0dfa8e8-31dc-4033-8382-ecdf9b8c1a50'
  ]
};
